module.exports = __webpack_public_path__ + "static/media/slide2.091a286d.jpg";